export default __webpack_public_path__ + "static/media/22.443f6650.png";